module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/small-docx-no-image-a2aab5418e473a82d553bc2e24faa66d.png";